import PageHeader from "app/shared/PageHeader";
import "./Reports.scss";
import { forwardRef, useEffect, useImperativeHandle, useState, useRef } from "react";
import Loader from "app/shared/Loader";
import { AgTableClient } from "app/shared/AgTable";
import { useMemo } from "react";
import moment from "moment";
import { Checkbox } from "antd";
import Typography from "app/shared/Typography";
import { Button, Input, message, Modal, Popconfirm, Select, Tag, Tabs, Switch } from "antd";
import { EyeOutlined, PlusOutlined, DeleteOutlined, SaveOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { apiDelete, apiPost, apiPut } from "app/services/apiServices";
import { getSubdomain } from "app/utils/generic.helper";
import {
  API_ENDPOINT_REPORT_LEGACY_LIST,
  API_ENDPOINT_REPORT_MANAGER_LIST,
} from "../ReportManager/report.manager.constant";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import {
  API_ENDPOINT_REPORTS_REMOVE_FROM_WORKSPACE,
  API_ENDPOINT_REPORTS_REMOVE_FROM_WORKSPACE_NEW,
} from "./reports.constants";
import AddWorksapceReport from "../Settings/components/WorkspaceMetaSetting/components/AddWorksapceReport";
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
import axios from "axios";
const Reports = forwardRef((props: any, ref: any) => {
  const [showModal, setShowModal] = useState(false);
  const [showDashboardModal, setShowDashboardModal] = useState(false);
  const [reportList, setReportList] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedWorkspace, setSelectedWorkspace] = useState<any>(null);
  const [creating, setCreating] = useState(false);
  const [selectedReport, setSelectedReport] = useState<any>(null);
  const [reportName, setReportName] = useState("");
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const [showModalFor, setShowModalFor] = useState("");
  const domain = getSubdomain();




  const [activeTab, setActiveTab] = useState("1");


  const items = [
    {
      key: "1",
      label: "Dashboard List",
    },
    {
      key: "2",
      label: "Report List", 
    },
  ];


  const handleTabChange = (key: string) => {
    setActiveTab(key);
    setHasOrderChanged(false);

    if (key === "2") {
      fetchReportList(key); // Pass the tab key
    }
  };




  useEffect(() => {
    fetchReportList();
  }, [userDetails.currentWorkspace]);


  useEffect(() => {
    FinkAnalytics("navbar_option_clicked", {
      option_name: "Reports",
      workspace_name: userDetails.currentWorkspace?.name,
      subdomain: window.location.hostname.split('.')[0],
    });


  }, []);




  const fetchLegacyReport = async (newReportList: any, tabKey?: string) => {

    setLoading(true);
    const response = await apiPost(API_ENDPOINT_REPORT_LEGACY_LIST, {
      workspace_id: userDetails.currentWorkspace?.id,
    });


    if (response.status) {
      let reportLists: any = [];
      response.data.forEach((reportItem: any) => {
        (reportItem.reports || []).forEach((reportData: any) => {
          reportLists.push({
            report_version_type: "LEGACY",
            report_name: reportData.report_name,
            report_link: reportData.embedurl,
            criteria: reportData.criteria,
          });
        });
      });
      setReportList([...newReportList, ...reportLists]);
    }

    // Use the passed tabKey instead of activeTab state
    const currentTab = tabKey || activeTab;

    if (currentTab === "2") {
      const email = (userDetails?.email || "").toLowerCase();

      let dashboards = (response.data || []).flatMap((item: any) =>
        (item.dashboards || []).map((dashboard: any) => ({
          ...dashboard,
          workspace_id: item.workspace_id,
        }))
      );


      // :no_entry: Filter out inactive dashboards for non-internal users
      const isInternalUser = email.includes("finkraft.ai") || email.includes("kgrp.in");

      if (!isInternalUser) {
        const beforeCount = dashboards.length;
        dashboards = dashboards.filter(
          (item: any) => item.dashboardStatus === true || item.dashboardStatus === "Active"
        );
      } else {
      }

      setDashboardList(dashboards);
      setOriginalDashboardOrder([...dashboards]);
      setHasOrderChanged(false);
    } else {
    }
    setLoading(false);
  };


  useImperativeHandle(ref, () => ({
    fetchReportList() {
      fetchReportList();
    },
  }));




  const fetchReportList = async (tabKey?: string) => {
    setLoading(true);
    const response = await apiPost(API_ENDPOINT_REPORT_MANAGER_LIST, {
      workspace_id: userDetails.currentWorkspace?.id,
    });
    if (response.status) {
      fetchLegacyReport(response.data, tabKey); // Pass tabKey to fetchLegacyReport
    } else {
    }
    // setLoading(false);
  };
  const [dashboardList, setDashboardList] = useState<any[]>([]);
  const [originalDashboardOrder, setOriginalDashboardOrder] = useState<any[]>([]);
  const [hasOrderChanged, setHasOrderChanged] = useState(false);
  const [savingOrder, setSavingOrder] = useState(false);
  const gridRef = useRef<any>(null);


  const handleRemoveWorkspace = async (type: string, reportName: string) => {
    const payload = {
      workspaceId: userDetails?.currentWorkspace?.id,
      type: type,
      report_name: reportName,
    };
    const response = await apiDelete(
      API_ENDPOINT_REPORTS_REMOVE_FROM_WORKSPACE,
      payload
    );
    if (response.status) {
      message.success("Report has been removed");
      fetchReportList();
    } else {
      message.error("Could not remove report from workspaces");
    }
  };


  const handleNewRemoveWorkspace = async (type: string, reportId: string) => {
    const payload = {
      workspaceId: userDetails?.currentWorkspace?.id,
      type: type,
      reportId: reportId,
    };
    const response = await apiDelete(
      API_ENDPOINT_REPORTS_REMOVE_FROM_WORKSPACE_NEW,
      payload
    );
    if (response.status) {
      message.success("Report has been removed");
      fetchReportList();
    } else {
      message.error("Could not remove report from workspaces");
    }
  };


  const navigate = useNavigate();




  const updateDashboardStatusApi = async (
    workspaceId: string,
    reportName: string,
    status: boolean
  ) => {
    try {
      const payload = {
        workspaceid: workspaceId,
        report_name: reportName,
        dashboardStatus: status,
      };



      const response = await fetch(
        "https://stage-apiplatform.finkraftai.com/api/meta/updateStatus/dashboard",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );


      const data = await response.json();


      if (response.ok) {
        message.success(`Dashboard status updated to ${status ? "Active" : "Inactive"}`);
        return true;
      } else {
        message.error(data?.message || "Failed to update dashboard status");
        return false;
      }
    } catch (error) {
      message.error("Network error while updating dashboard status");
      return false;
    }
  };

  const handleDeleteDashboard = async (
    workspaceId: string,
    reportName: string
  ) => {
    try {
      const payload = {
        workspace_id: workspaceId,
        report_name: reportName,
      };

      const response = await fetch(
        "https://stage-apiplatform.finkraftai.com/api/meta/delete/dashboard",
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        message.success("Dashboard deleted successfully");
        // Refresh dashboard list
        if (activeTab === "2") {
          fetchReportList("2");
        }
        return true;
      } else {
        message.error(data?.message || "Failed to delete dashboard");
        return false;
      }
    } catch (error) {
      message.error("Network error while deleting dashboard");
      return false;
    }
  };

  const checkOrderChanged = (currentList: any[], originalList: any[]) => {
    if (!originalList || originalList.length === 0) {
      return false;
    }
    if (currentList.length !== originalList.length) {
      return true;
    }
    return currentList.some((item, index) => {
      const originalItem = originalList[index];
      return item.report_name !== originalItem?.report_name || 
             item.embedurl !== originalItem?.embedurl;
    });
  };

  const handleSaveDashboardOrder = async () => {
    if (!hasOrderChanged) {
      return;
    }

    setSavingOrder(true);
    try {
      const payload = {
        workspaceid: userDetails?.currentWorkspace?.id,
        dashboardOrder: dashboardList.map((dashboard, index) => ({
          report_name: dashboard.report_name,
          embedurl: dashboard.embedurl,
          order: index + 1,
        })),
      };

      const response = await fetch(
        "https://stage-apiplatform.finkraftai.com/api/meta/updateDashboardOrder",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        message.success("Dashboard order saved successfully!");
        setOriginalDashboardOrder([...dashboardList]);
        setHasOrderChanged(false);
      } else {
        message.error(data?.message || "Failed to save dashboard order");
      }
    } catch (error) {
      message.error("Network error while saving dashboard order");
    } finally {
      setSavingOrder(false);
    }
  };


  const columnDefs = useMemo(() => {
    if (activeTab === "1") {
      // Report List Columns
      return [
        {
          field: "report_name",
          headerName: "Report Name",
          width: 200,
        },
        {
          field: "report_version_type",
          headerName: "Report Version",
          width: 200,
          cellRenderer: (params: any) => (
            <Tag
              color={
                params.data.report_version_type === "LEGACY" ? "yellow" : "green"
              }
            >
              {params.data.report_version_type}
            </Tag>
          ),
        },
        {
          field: "Action",
          headerName: "Action",
          width: 400,
          cellRenderer: (params: any) => (
            <div>
              <Button
                size="small"
                icon={<EyeOutlined />}
                onClick={() => {
                  FinkAnalytics("user_clicked_view_report", {
                    event_category: "navigation",
                    event_label: "Clicked View Report",
                    report_type: params.data.report_version_type,
                    report_name: params.data.report_name,
                    workspace_id: params.data.workspace_id,
                    user_identifier: userDetails?.id || "",
                  });
                  if (params.data.report_version_type === "LEGACY") {
                    navigate("/report/legacy/view", {
                      state: {
                        report_link: params.data.report_link,
                        zoho_criteria: params.data?.criteria,
                      },
                    });
                  } else {
                    navigate("/report/view/" + params.data?._id, {
                      state: {
                        dbType: params.data?.meta?.dbType,
                        database: params.data?.meta?.database,
                        table: params.data?.meta?.table,
                        report_name: params.data?.report_name,
                        selectedWorkspaceId: params.data?.workspace_id,
                      },
                    });
                  }
                }}
              >
                View
              </Button>
              <Popconfirm
                placement="topLeft"
                title="Are you sure want to remove the report from current selected workspace"
                okText="Yes"
                cancelText="No"
                onConfirm={() =>
                  params.data.report_version_type === "LEGACY"
                    ? handleRemoveWorkspace("SINGLE", params.data?.report_name)
                    : handleNewRemoveWorkspace("SINGLE", params.data?.id)
                }
              >
                <Button
                  size="small"
                  icon={<DeleteOutlined />}
                  style={{ marginLeft: 12 }}
                  danger
                >
                  Remove Report
                </Button>
              </Popconfirm>
              <Popconfirm
                placement="topLeft"
                title="Are you sure want to remove the report from all workspaces"
                okText="Yes"
                cancelText="No"
                onConfirm={() =>
                  params.data.report_version_type === "LEGACY"
                    ? handleRemoveWorkspace("ALL", params.data?.report_name)
                    : handleNewRemoveWorkspace("ALL", params.data?.id)
                }
              >
                <Button
                  size="small"
                  icon={<DeleteOutlined />}
                  danger
                  style={{ marginLeft: 12 }}
                >
                  Remove From All Workspace
                </Button>
              </Popconfirm>
            </div>
          ),
        },
      ];
    } else {
      // Dashboard List Columns
      return [
        {
          field: "report_name",
          headerName: "Dashboard Name",
          width: 200,
          rowDrag: true,
          suppressMenu: true,
        },
        // {
        //   field: "embedurl",
        //   headerName: "Action",
        //   width: 400,
        //   cellRenderer: (params: any) => (
        //     <Button
        //       size="small"
        //       icon={<EyeOutlined />}
        //       onClick={() =>
        //         navigate("/report/dashboard/view", {
        //           state: {
        //             dashboard_link: params.value,
        //             zoho_criteria: params.data.zoho_criteria, // if exists
        //           },
        //         })
        //       }
        //     >
        //       View
        //     </Button>
            
        //   ),
        // },
        {
  field: "embedurl",
  headerName: "Action",
  width: 400,
  cellRenderer: (params: any) => (
    <div style={{ display: "flex", gap: "8px" }}>
      
      <Button
        size="small"
        icon={<EyeOutlined />}
        onClick={() =>
          navigate("/report/dashboard/view", {
            state: {
              dashboard_link: params.value,
              zoho_criteria: params.data.zoho_criteria,
            },
          })
        }
      >
        View
      </Button>

      <Popconfirm
        placement="topLeft"
        title="Are you sure you want to delete this dashboard?"
        okText="Yes"
        cancelText="No"
        onConfirm={() =>
          handleDeleteDashboard(
            params.data.workspace_id,
            params.data.report_name
          )
        }
      >
        <Button
          size="small"
          danger
          icon={<DeleteOutlined />}
        >
          Delete
        </Button>
      </Popconfirm>

    </div>
  ),
},

        {
          field: "dashboardStatus",
          headerName: "Status",
          width: 400,
          cellRenderer: (params: any) => {
            const handleConfirm = async (checked: boolean) => {
              const success = await updateDashboardStatusApi(
                params.data.workspace_id,
                params.data.report_name,
                checked
              );


              if (success) {
                // Update AG Grid cell
                params.node.setDataValue("dashboardStatus", checked ? "Active" : "Inactive");


                // Also update React state so UI remains consistent
                setDashboardList((prev) =>
                  prev.map((item) =>
                    item.report_name === params.data.report_name
                      ? { ...item, dashboardStatus: checked ? "Active" : "Inactive" }
                      : item
                  )
                );
              }
            };


            const isActive = params.value === true || params.value === "Active";


            return (
              <Popconfirm
                title="Are you sure you want to change the dashboard status?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleConfirm(!isActive)}
              >
                <Switch checked={isActive} size="small" onChange={() => { }} />
              </Popconfirm>
            );
          },
        }




      ];
    }


  }, [activeTab]);




  const handleSelectWorkspace = (spaceInfo: any, fullObj: any) => {
    setSelectedWorkspace(spaceInfo);
  };


  const { Option } = Select;
  const copyDataToBoard = (data: any) => {
    navigator?.clipboard?.writeText(data);
    messageApi.open({
      type: "success",
      content: "copied",
    });
  };




  const [dashboardName, setDashboardName] = useState("");
  const [dashboardUrl, setDashboardUrl] = useState("");
  const [addForAll, setAddForAll] = useState(false);
  const [selectedWorkspaceIds, setSelectedWorkspaceIds] = useState<string[]>([]);
  const [workspaceSelection, setWorkspaceSelection] = useState<"ALL" | "MULTIPLE" | null>(null);
  //const [isLoading, setIsLoading] = useState(false);


  const handleCreate = async () => {
    if (!dashboardName || !dashboardUrl) {
      message.error("Please fill in both fields.");
      return;
    }


    // Determine workspace IDs
    const workspaceIdsToSend =
      workspaceSelection === "ALL"
        ? userDetails?.workspaces?.map((ws: any) => ws.id) || []
        : selectedWorkspaceIds;


    if (workspaceIdsToSend.length === 0) {
      message.error("Please select at least one workspace.");
      return;
    }


    ///setIsLoading(true);


    try {
      // Send API requests for each workspace
      await Promise.all(
        workspaceIdsToSend.map((workspaceId: string) =>
          axios.post("https://stage-apiplatform.finkraftai.com/api/meta/create/dashboard", {
            embedurl: dashboardUrl,
            report_name: dashboardName,
            //dashboardStatus: false,
            workspaceid: workspaceId,
          })
        )
      );


      message.success("Dashboard created successfully!");
      setDashboardName("");
      setDashboardUrl("");
      setSelectedWorkspaceIds([]);
      setWorkspaceSelection(null);
      setShowDashboardModal(false);
      // Refresh dashboard list to include the new dashboard
      if (activeTab === "2") {
        fetchReportList("2");
      }
      //onSuccess && onSuccess();
    } catch (error) {
      message.error("Failed to create dashboard");
    } finally {
      //setIsLoading(false);
    }
  };




  return (
    <div className="ReportSelection">
      {props.noHeader ? null : (
        <div className="HeaderContainer">
          <PageHeader
            leftActions={
              <Tabs
                items={items}
                // items={
                //   domain === "app"
                //     ? items 
                //     : items.filter((tab: any) => tab.key === "1") 
                // }
                tabBarStyle={{
                  borderBottom: "none", // Remove the underline border
                  margin: 0,
                }}
                activeKey={activeTab}
                // onChange={(tabItem: string) => setActiveTab(tabItem)}
                onChange={handleTabChange}
              />
            }
            rightActions={

              
              userDetails.email.includes("finkraft.ai") ||
                userDetails.email.includes("kgrp.in") ? (
                <div>

                  {activeTab === "2" && (
                    <>
                      {hasOrderChanged && (
                        <Button
                          icon={<SaveOutlined />}
                          size="small"
                          type="primary"
                          loading={savingOrder}
                          onClick={handleSaveDashboardOrder}
                          style={{ marginRight: 12 }}
                        >
                          Save Order
                        </Button>
                      )}
                      <Button
                        icon={<PlusOutlined />}
                        size="small"
                        type="primary"
                        onClick={() => setShowDashboardModal(true)}
                      >
                        Add New Dashboard
                      </Button>
                    </>
                  )}


                  {activeTab === "1" && (
                    <>
                      <Button
                        icon={<PlusOutlined />}
                        size="small"
                        type="primary"
                        onClick={() => navigate("/reportmanager/create")}
                        style={{ marginLeft: 12 }}
                      >
                        Create New Report
                      </Button>


                      <Button
                        type="primary"
                        size="small"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setShowModalFor("REPORT");
                          setShowModal(true);
                        }}
                        style={{ marginLeft: 12 }}
                      >
                        Add Legacy Report
                      </Button>
                    </>
                  )}


                </div>
              ) : null
            }
          />
        </div>
      )}
      <div className="MainContainer">
        {isLoading ? (
          <Loader />
        ) : (
          <AgTableClient
            // @ts-ignore
            //rowData={domain === "newdemo" ? [] : reportList} // new
            rowData={
              domain === "newdemo"
                ? []
                : activeTab === "1"
                  ? reportList
                  : dashboardList
            }


            columnDefs={columnDefs}
            hideToolbar
            autoResize
            enableDragging={activeTab === "2"}
            dragColumn={activeTab === "2" ? "report_name" : undefined}
            ref={gridRef}
            updateNewData={activeTab === "2" ? (data: any) => {
              if (data && Array.isArray(data) && data.length > 0) {
                setDashboardList(data);
                const hasChanged = checkOrderChanged(data, originalDashboardOrder);
                setHasOrderChanged(hasChanged);
              }
            } : undefined}
          />
        )}
      </div>


      {contextHolder}
      <Modal
        title="Add New Dashboard"
        open={showDashboardModal}
        footer={false}
        onCancel={() => setShowDashboardModal(false)}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <div>
            <label style={{ fontWeight: 500, marginBottom: 4, display: "block" }}>
              Dashboard Name
            </label>
            <Input
              placeholder="Enter dashboard name"
              value={dashboardName}
              onChange={(e) => setDashboardName(e.target.value)}
            />
          </div>


          <div>
            <label style={{ fontWeight: 500, marginBottom: 4, display: "block" }}>
              Dashboard URL
            </label>
            <Input
              placeholder="Enter dashboard URL"
              value={dashboardUrl}
              onChange={(e) => setDashboardUrl(e.target.value)}
            />
          </div>


          {/* Workspace selection */}
          <div>
            <label style={{ fontWeight: 500, marginBottom: 4, display: "block" }}>
              Select Workspace
            </label>
            <Select
              mode="multiple"
              options={[
                { value: "ALL", label: "All Workspaces" },
                ...(userDetails?.workspaces || []).map((ws: any) => ({
                  value: ws.id,
                  label: ws.name,
                })),
              ]}
              placeholder="Select Workspace(s)"
              value={
                workspaceSelection === "ALL"
                  ? ["ALL"]
                  : selectedWorkspaceIds
              }
              style={{ width: "100%" }}
              onChange={(workspaceIds: string[]) => {
                if (workspaceIds.includes("ALL")) {
                  setSelectedWorkspaceIds([]);
                  setWorkspaceSelection("ALL");
                } else {
                  setSelectedWorkspaceIds(workspaceIds);
                  setWorkspaceSelection("MULTIPLE");
                }
              }}
              allowClear
              showSearch
              optionFilterProp="label"
            />
          </div>


          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button onClick={() => setShowDashboardModal(false)}>Cancel</Button>
            <Button type="primary" onClick={handleCreate} loading={isLoading}>
              Create Dashboard
            </Button>
          </div>
        </div>
      </Modal>




      <Modal
        title={
          showModalFor === "REPORT"
            ? "Add Legacy(ZA) Report"
            : `Dupliate - ${selectedReport?.report_name}`
        }
        open={showModal}
        footer={false}
        onCancel={() => setShowModal(false)}
      >
        {showModalFor === "REPORT" ? (
          <AddWorksapceReport
            onSuccess={() => {
              fetchReportList();
              setShowModal(false);
              setShowModalFor("");
            }}
          />
        ) : (
          <div style={{ marginTop: 24 }}>
            <Input
              placeholder="Report Name"
              onChange={(e: any) => setReportName(e.target.value)}
            />


            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                style={{ marginTop: 24 }}
                size="small"
                type="primary"
                loading={creating}
                //@ts-ignore
                onClick={() => handleCreateDuplicateReport(selectedReport?._id)}
              >
                Create Duplicate
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
});
export default Reports;



